import { useFormContext } from 'react-hook-form';

import type { RadioProps } from '@/components/Radio';
import { Radio } from '@/components/Radio';

export interface RadioFieldProps extends RadioProps {
  name: string;
}

// TODO: Add error message
export const RadioField = ({ name, ...props }: RadioFieldProps) => {
  const { register } = useFormContext();

  return (
    <Radio data-test-id={`RadioField-${name}`} {...register(name)} {...props} />
  );
};
